// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"35c5cbac","455":"7f7fd7f2","977":"8942f0cf"}[chunkId] + ".chunk.js";
};